module.exports = __webpack_public_path__ + "Server-Default-AzureCloudService.60ef35b29ce2113e2f54b16c03ab418e.hashedasset.svg";